import { defaultI18nConfig } from '../../i18n';
import { t } from '../../util/i18n-tool';
import { BuiltInErrorType, ErrorTypeCodeMap } from './constants';
/**
 * 错误基类，兼容已有的IVideoError
 *
 * @export
 * @class ErrorBase
 * @typedef {ErrorBase}
 * @implements {IVideoError}
 */
var ErrorBase = /** @class */ (function () {
    function ErrorBase(type, config) {
        /** 详细错误码 */
        this.detail = null;
        var code = config.code, detail = config.detail, message = config.message, fatal = config.fatal, debugMessage = config.debugMessage;
        this.type = type;
        this.errorCode = code;
        this.detail = detail !== null && detail !== void 0 ? detail : null;
        this.fatal = fatal !== null && fatal !== void 0 ? fatal : false;
        this.message = message !== null && message !== void 0 ? message : t(defaultI18nConfig.core.ERROR_MSG_UNKNOWN);
        this.debugMessage = debugMessage;
    }
    Object.defineProperty(ErrorBase.prototype, "code", {
        /** 外显的完整错误码 */
        get: function () {
            var base = this.type === BuiltInErrorType.Custom
                ? "".concat(this.errorCode)
                : "".concat(ThumbPlayerErrorPrefix).concat(ErrorTypeCodeMap[this.type]).concat(patchCode(this.errorCode));
            if (this.detail) {
                return "".concat(base, ".").concat(this.detail);
            }
            return base;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 通过code比较两个error是否相同
     */
    ErrorBase.prototype.equals = function (other, strict) {
        if (strict === void 0) { strict = false; }
        if (other instanceof ErrorBase) {
            return this.type === other.type
                && this.errorCode === other.errorCode
                && (strict ? this.detail === other.detail : true);
        }
        return this.code === (other === null || other === void 0 ? void 0 : other.code);
    };
    // log工具，用于序列化错误对象
    ErrorBase.prototype.toString = function () {
        return this.serialize();
    };
    ErrorBase.prototype.toJSON = function () {
        return this.serialize();
    };
    ErrorBase.prototype.serialize = function () {
        var _a, _b;
        return "error=".concat(this.code, ";fatal=").concat(+this.fatal, ";msg=").concat((_b = (_a = this.debugMessage) !== null && _a !== void 0 ? _a : this.message) !== null && _b !== void 0 ? _b : '');
    };
    return ErrorBase;
}());
export { ErrorBase };
;
/** 中台播放器的固定错误码前缀 */
var ThumbPlayerErrorPrefix = '700';
/** string padStart的简化版 */
function patchCode(code) {
    return "000".concat(code).slice(-3);
}
